import { useState, useRef, useEffect } from 'react';

export default function SearchSelect({ options, title, count, addTeamMember }) {
  const [value, setValue] = useState('');
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [showDropdown, setShowDropdown] = useState(false);
  const inputRef = useRef();

  useEffect(() => {
    if (value.trim() === '') {
      setFilteredOptions(options);
    } else {
      setFilteredOptions(
        options.filter((option) =>
          option.name.toLowerCase().includes(value.toLowerCase())
        )
      );
    }
  }, [value, options]);

  const handleSelect = (option) => {
    addTeamMember(option.employee_id, title, option.tenure, option.title);
    setValue('');
    setShowDropdown(false);
  };

  return (
    <div className="w-full relative">
      {(title === 'Setter' || title === 'Closer') && count ? (
        <p className="mb-2">Select {count} {title} Team Members</p>
      ) : null}
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          setShowDropdown(true);
        }}
        placeholder="Search for rep"
        className="w-full p-1 border border-gray-300 rounded-md focus:outline-none focus:ring-0"
        onFocus={() => setShowDropdown(true)}
        onBlur={() => {
          // delay closing so click event can register
          setTimeout(() => setShowDropdown(false), 100);
        }}
      />
      {showDropdown && filteredOptions.length > 0 && (
        <ul className="absolute z-10 w-full bg-white border border-gray-300 rounded-md mt-1 max-h-60 overflow-y-auto shadow-md">
          {filteredOptions.map((option) => (
            <li
              key={option.employee_id}
              onMouseDown={() => handleSelect(option)}
              className="px-3 py-2 cursor-pointer hover:bg-gray-100 flex justify-between items-center"
            >
              <span>{option.name}</span>
              <span
                className={`${
                  option.tenure === 'VETERAN' || option.title === 'Closer'
                    ? 'bg-yellow-100 text-yellow-500'
                    : 'bg-gray-200 text-gray-500'
                } rounded-full px-2 py-1 text-xs`}
              >
                {title === 'Rookie & Veteran' ? option.tenure : option.title}
              </span>
            </li>
          ))}
        </ul>
      )}
      {showDropdown && filteredOptions.length === 0 && (
        <div className="absolute z-10 w-full bg-white rounded-md mt-1 p-2 text-gray-500 text-sm">
          No results found
        </div>
      )}
    </div>
  );
}
